export default {
  titles: {
    default: 'Scheduled order reminder!',
    external_delivery: 'Driver assigned!',
  },
  labels: {
    pickup: 'Pickup: {{time}}',
    preparation_time: 'Preparation time: {{time}} min',
  },
  buttons: {
    confirm: 'Start preparing now',
    print_and_confirm: 'Print & start preparing now',
  },
  toasts: {
    something_went_wrong: 'Something went wrong, please try again',
  },
};
